import { render } from "./ContentSubheader.vue?vue&type=template&id=72197638"
import script from "./ContentSubheader.vue?vue&type=script&lang=js"
export * from "./ContentSubheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__